import StorageService from 'services/StorageService';
import { api } from 'config/index'

const _sendEvent = (payload) => {
    return fetch(`${api.user}/personalize/event`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json'
        }
    }).then(results => results.json());
}

const PersonalizeService = {
    addToCart: (items) => {
        const data = StorageService.getSecureItem('userData');
        const orderFormId = StorageService.getItem('orderFormId');
        const sessionId = StorageService.getItem('sessionId');
        if(!(data && data.gtmSegment && orderFormId && sessionId)) return false;

        const segmentId = data.gtmSegment;
        const eventType = 'addToCart';

        const payload = {
            eventType,
            segmentId,
            sessionId,
            orderId: orderFormId,
            items: items.map(item => {
                return {
                    itemId: item.itemId,
                    name: item.name,
                    quantity: item.quantity
                }
            })
        }

        _sendEvent(payload);
    },
    preview: (item) => {
        const data = StorageService.getSecureItem('userData');
        const orderFormId = StorageService.getItem('orderFormId');
        const sessionId = StorageService.getItem('sessionId');
        if(!(data && data.gtmSegment && orderFormId && sessionId)) return false;

        const segmentId = data.gtmSegment;
        const eventType = 'preview';

        const payload = {
            eventType,
            segmentId,
            sessionId,
            orderId: orderFormId,
            items: [
                {
                    itemId: item.itemId,
                    name: item.name
                }
            ]
        }

        _sendEvent(payload);
    },
    purchase: (orderId, items) => {
        const data = StorageService.getSecureItem('userData');
        const sessionId = StorageService.getItem('sessionId');
        if(!(data && data.gtmSegment && sessionId)) return false;

        const segmentId = data.gtmSegment;
        const eventType = 'purchase';

        const payload = {
            eventType,
            segmentId,
            sessionId,
            orderId,
            items: items.map(item => {
                return {
                    itemId: item.id,
                    name: item.name,
                    quantity: item.quantity
                }
            })
        }

        _sendEvent(payload);
    }
}

export default PersonalizeService;
